import { CHANGE_PASSWORD_FAILURE, CHANGE_PASSWORD_REQUEST, CHANGE_PASSWORD_SUCCESS, RESET_CHANGE_PASSWORD } from "./ChangePasswordType";

export const changePasswordRequest=(payload)=>({
    
   type:CHANGE_PASSWORD_REQUEST,
   payload:payload,
});
export const changePasswordSuccess=(payload)=>({
        type:CHANGE_PASSWORD_SUCCESS,
        payload:payload
});
export const changePasswordFailure=(payload)=>({
    type:CHANGE_PASSWORD_FAILURE,
    payload:payload
})
export const resetChangePassword=()=>({
    type:RESET_CHANGE_PASSWORD
})